const ROUTES = {
  MAIN: '/',
  LOGIN: '/login',
  HISTORY: '/history',
  CUPS: { MAIN: '/cup', COMPETITION: '/cup/competitions' },
};

export { ROUTES };
